export default __webpack_public_path__ + "static/media/Gilroy-Bold.0607a1bc.woff";